<script setup lang="ts">
/**
 * 「打开 SVG / 打开工程」按钮 —— label 套隐藏 input 的转发只写一次。
 * 工程文件会连视图态 / 锁定态一起恢复，所以是两个 kind，而不是两个组件。
 */
import { useEditor } from '@/composables/useEditor';

const props = defineProps<{ kind: 'svg' | 'project'; label: string }>();
const editor = useEditor();

const ACCEPT = { svg: '.svg,image/svg+xml', project: '.json,application/json' } as const;

const onPick = async (e: Event): Promise<void> => {
  const input = e.target as HTMLInputElement;
  const file = input.files?.[0];
  if (file) await (props.kind === 'svg' ? editor.openFile(file) : editor.openProjectFile(file));
  input.value = ''; // 不清空的话，再选同一个文件不会触发 change
};
</script>

<template>
  <label>
    {{ label }}
    <input type="file" :accept="ACCEPT[kind]" hidden @change="onPick" />
  </label>
</template>
